import { create } from "zustand";
import { query } from "../defaults/fetch";

export const getUserProfile = async ()=>{
    const profileEndpoint = 'get-current-user';
    const response = await query(profileEndpoint);
    return response.data;
}


export const userStore = create((set,get)=>({
        user:{},
        setUser: (profile)=>set(()=>({user:{...profile}})),
        logout: ()=>set(()=>({user:{}})),
        getUser: ()=>get().user
    }))